import { DATABASE_UPDATE } from "../actions/database";
import { differenceInMinutes, getCorrectedTime } from "../time";
import { raceSetIsSoon } from "../actions/race";

const refreshIfOlderThanMinutes = 5;
var raceTimeouts = {};

export default store => next => action => {
  next(action);
  if (action.type === DATABASE_UPDATE && action.tables && action.tables.races) {
    var now = getCurrentTime(store);
    action.tables.races.forEach((race) => checkRaceTime(next, now, race));
  }
};

function getCurrentTime(store) {
  var state = store.getState();

  var timeDiff = 0;
  if (state.time) {
    timeDiff = state.time.get("serverTimeDifference") || 0;
  }
  return getCorrectedTime(new Date(), timeDiff);
}

function checkRaceTime(next, now, race) {
  var minutesLeft = differenceInMinutes(new Date(race.post_time), now);
  race.isSoon = minutesLeft < refreshIfOlderThanMinutes;
  if (raceTimeouts[race.id]) {
    window.clearTimeout(raceTimeouts[race.id]);
    delete raceTimeouts[race.id];
  }
  if (minutesLeft >= refreshIfOlderThanMinutes) {
    var timeoutMS = ((minutesLeft - refreshIfOlderThanMinutes) * 60 * 1000) + 1000;

    raceTimeouts[race.id] = window.setTimeout(() => {
      delete raceTimeouts[race.id];
      next(raceSetIsSoon(race.id));
    }, timeoutMS);
  }
}
